var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { EditorState } from "@reactivepad/codemirror-next/state";
import { EditorView } from "@reactivepad/codemirror-next/view";
import { baseKeymap, indentSelection, selectAll } from "@reactivepad/codemirror-next/commands";
import { defaultHighlighter } from "@reactivepad/codemirror-next/highlight";
import { bracketMatching } from "@reactivepad/codemirror-next/matchbrackets";
import { autocomplete, startCompletion, sortAndFilterCompletion } from "@reactivepad/codemirror-next/autocomplete";
import { keymap } from "@reactivepad/codemirror-next/keymap";
import { history, redo, redoSelection, undo, undoSelection } from "@reactivepad/codemirror-next/history";
import * as formulaLang from "./language/formula";

export { formulaLang };

var isMac = /Mac/.test(navigator.platform);

var FormulaEditor = (_temp2 = _class = function (_Component) {
  _inherits(FormulaEditor, _Component);

  function FormulaEditor() {
    var _temp, _this, _ret;

    _classCallCheck(this, FormulaEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleEditorRef = function (el) {
      return _this.editorRef = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FormulaEditor.prototype.componentDidMount = function componentDidMount() {
    var _keymap;

    var _props = this.props,
        value = _props.value,
        onChange = _props.onChange,
        onSave = _props.onSave,
        completions = _props.completions,
        autoFocus = _props.autoFocus;


    var autoCompleteExt = autocomplete({
      completeAt: function completeAt(state, pos) {
        var _this2 = this;

        return new Promise(function (resolve) {
          var tree = state.tree.resolve(pos, -1);

          if (tree.name === "Name" && tree.end === pos) {
            var cs = completions.map(function (f) {
              return {
                label: f.name.toUpperCase(),
                apply: f.insertText,
                start: tree.start,
                end: pos
              };
            });
            var slice = state.doc.slice(tree.start, tree.end);

            // ToDo: clear timeout
            _this2.timeoutId = setTimeout(function () {
              var items = sortAndFilterCompletion(slice.toUpperCase(), cs);
              resolve({ items: items });
            }, 100);
          } else {
            resolve({ items: [] });
          }
        });
      }
    });
    var extensions = [history(), defaultHighlighter, formulaLang.formula(), bracketMatching(),
    // closeBrackets, ToDo
    autoCompleteExt, keymap((_keymap = {
      "Mod-z": undo,
      "Mod-Shift-z": redo,
      "Mod-u": function ModU(view) {
        return undoSelection(view) || true;
      }
    }, _keymap[isMac ? "Mod-Shift-u" : "Alt-u"] = redoSelection, _keymap["Ctrl-y"] = isMac ? undefined : redo, _keymap["Shift-Tab"] = indentSelection, _keymap["Ctrl-Space"] = startCompletion, _keymap.Enter = function Enter() {
      return onSave();
    }, _keymap)), keymap(baseKeymap)];

    var state = EditorState.create({ doc: value, extensions: extensions });
    var view = new EditorView({
      state: state,
      dispatch: function dispatch(_tr) {
        var tr = _tr;
        var text = tr.doc.text;


        if (Array.isArray(text) && text.length > 1) {
          selectAll(view);
          tr = view.state.t().replaceSelection(text.join(!text[1] ? "" : " "));
        }

        view.update(Array.isArray(tr) ? tr : [tr]);
        onChange(tr.state);
      }
    });
    this.editorRef.appendChild(view.dom);
    this.view = view;

    if (autoFocus) {
      view.focus();
    }
  };

  FormulaEditor.prototype.componentWillUnmount = function componentWillUnmount() {
    this.timeoutId && clearTimeout(this.timeoutId);
    this.view.destroy();
  };

  FormulaEditor.prototype.render = function render() {
    var _props2 = this.props,
        style = _props2.style,
        className = _props2.className;


    return React.createElement("div", { style: style, className: className, ref: this.handleEditorRef });
  };

  return FormulaEditor;
}(Component), _class.defaultProps = {
  value: "",
  onChange: function onChange() {},
  onSave: function onSave() {},
  completions: [],
  autoFocus: true
}, _temp2);


export default FormulaEditor;